const initialState = {
  loading: true,
  detail: [],
  option: {},
  query: {},
  bookingAddress: "",
  bookingTimeVisible: false,
  bookingTime: [],
  bookingShopVisible: false,
  shopId: ""
};

function reducer(state, action) {
  switch (action.type) {
    case "setLoading":
      return { ...state, loading: action.payload };
    case "setDetail":
      return { ...state, detail: action.payload };
    case "setOption":
      return { ...state, option: action.payload };
    case "setShopId":
      return {...state, shopId: action.payload}
    case "setQuery":
      return { ...state, query: action.payload };
    case "setBookingAddress":
      return { ...state, bookingAddress: action.payload };
    case "setBookingTimeVisible":
      return { ...state, bookingTimeVisible: action.payload };
    case "setBookingTime":
      return { ...state, bookingTime: action.payload };
    case "setBookingShopVisible":
      return { ...state, bookingShopVisible: action.payload };
    default:
  }
}

const setLoading = (payload) => ({
  type: "setLoading",
  payload,
});

const setDetail = (payload) => ({
  type: "setDetail",
  payload,
});

const setOption = (payload) => ({
  type: "setOption",
  payload,
});

const setShopId = (payload) => ({
  type: "setShopId",
  payload
})

const setQuery = (payload) => ({
  type: "setQuery",
  payload,
});

const setBookingAddress = (payload) => ({
  type: "setBookingAddress",
  payload,
});

const setBookingTimeVisible = (payload) => ({
  type: "setBookingTimeVisible",
  payload,
});

const setBookingTime = (payload) => ({
  type: "setBookingTime",
  payload,
});

const setBookingShopVisible = (payload) => ({
  type: "setBookingShopVisible",
  payload,
});

export {
  initialState,
  reducer,
  setLoading,
  setDetail,
  setOption,
  setShopId,
  setQuery,
  setBookingAddress,
  setBookingTimeVisible,
  setBookingTime,
  setBookingShopVisible,
};
